import { render, staticRenderFns } from "./userRegist.vue?vue&type=template&id=4f38dd75&scoped=true"
import script from "./userRegist.vue?vue&type=script&lang=js"
export * from "./userRegist.vue?vue&type=script&lang=js"
import style0 from "./userRegist.vue?vue&type=style&index=0&id=4f38dd75&prod&lang=less"
import style1 from "./userRegist.vue?vue&type=style&index=1&id=4f38dd75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f38dd75",
  null
  
)

export default component.exports